<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Clientes
					</h1>
				</div>
			    <button 
					class="btn btn-primary ml-2"
					@click="create()">
					Novo
				</button>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <cliente-table 
		            	@show="show" 
		            	:key="cliente_key">
		            </cliente-table>
		        </div>
		    </div>
		</div>
		<cliente-create
			@reload="reload()">
		</cliente-create>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				cliente_key: 0
			}
		},
		methods: {
			show(dado_id){
				this.$router.push('/adm/clientes/show/'+dado_id)
			},
			create(){
				$('#create_cliente').modal('show');
			},
			reload(){
				this.cliente_key += 1;
			}
		}
	}
</script>